import React from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { Title } from 'react-admin'
import config from '../config'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 450,
    margin: 'auto',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    padding: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: '#fafafa', // Light grey background for the card
  },
  illustration: {
    width: '100%',
    objectFit: 'contain',
    height: '200px', // Adjusted for better balance
    margin: theme.spacing(2, 0),
  },
  loginButton: {
    marginTop: theme.spacing(2),
    color: 'white',
    backgroundColor: '#1976d2', // A shade of blue for the button
    '&:hover': {
      backgroundColor: '#115293', // Darker shade on hover
    },
  },
}))

const AccountDisabled = () => {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <Title title="Account Disabled" />
      <CardContent>
        <img
          src={`${config.PUBLIC_URL}/img/401.png`}
          alt="Account Disabled"
          className={classes.illustration}
        />
        <Typography variant="h5" component="h2" gutterBottom>
          Compte Désactivé
        </Typography>
        <Typography variant="body1">
          Nous sommes désolés, mais votre compte a été désactivé. Si vous pensez
          qu'il s'agit d'une erreur, veuillez contacter l'administrateur pour
          obtenir de l'aide.
        </Typography>
        <Button
          href={`${window.location.origin}/oauth2/sign_in`}
          variant="contained"
          className={classes.loginButton}
        >
          Retour à la connexion
        </Button>
      </CardContent>
    </Card>
  )
}

export default AccountDisabled
